import { fork, takeEvery } from "redux-saga/effects";

import PerformanceConstants from "modules/performance/constants";
import PerformanceSagas from "modules/performance/sagas";
import PerformanceActions from "modules/performance/actions";

function* watchGetPerformanceList() {
  yield takeEvery(PerformanceConstants.GET_PERFORMANCE_LIST, PerformanceSagas.GetPerformanceList);
}

function* watchGetPerformanceVersus() {
  yield takeEvery(PerformanceConstants.GET_PERFORMANCE_VERSUS, PerformanceSagas.GetPerformanceVersus);
}

function* watchGetFBdashborads() {
  yield takeEvery(PerformanceConstants.GET_FBDASHBOARD_LIST, PerformanceSagas.GetFBDashboard);
}

function* watchGetFBreports() {
  yield takeEvery(PerformanceActions.GetFBReportList, PerformanceSagas.GetFBReport);
}

function* watchGetFBgraph() {
  yield takeEvery(PerformanceActions.GetFBGraph, PerformanceSagas.GetFBGraph);
}

function* watchGetGdashboard() {
  yield takeEvery(PerformanceConstants.GET_GDASHBOARD_LIST, PerformanceSagas.GetGDashboard);
}

function* watchGetGReport() {
  yield takeEvery(PerformanceActions.GetGReportList, PerformanceSagas.GetGReport);
}

function* watchGetGGraph() {
  yield takeEvery(PerformanceActions.GetGGraph, PerformanceSagas.GetGGraph);
}

export default [
  fork(watchGetPerformanceList),
  fork(watchGetPerformanceVersus),
  fork(watchGetFBdashborads),
  fork(watchGetFBreports),
  fork(watchGetFBgraph),
  fork(watchGetGdashboard),
  fork(watchGetGReport),
  fork(watchGetGGraph),
];
